<template>
  <div class="no-scroll-content">
    <!-- <vx-card class="no-scroll-content" title="List of Filed Overtimes" > -->
    <!-- <vs-input class='hidden' v-model="employeeOvertime" /> -->
    <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
    <!-- <vs-button type="gradient" @click="promptAddNewOvertime()" icon-pack="feather" icon="icon-file">Apply Overtime</vs-button> -->
    <vs-table
      stripe
      max-items="7"
      pagination
      v-model="selected"
      search
      :data="getEmployeeOvertimeRequests"
    >
      <template slot="thead">
        <vs-th>User</vs-th>
        <vs-th sort-key="createdOn">Schedule Date Applied</vs-th>
        <vs-th sort-key="oTDate">Day</vs-th>
        <vs-th>Scheduled In</vs-th>
        <vs-th>Scheduled Out</vs-th>
        <vs-th>Total Hours</vs-th>
        <vs-th>Remarks</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Actions</vs-th>
      </template>
    </vs-table>

    <!-- </vx-card> -->
  </div>
</template>

<script>
import moment from "moment";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      selected: [],
      employeeFiledOvertimeId: null,

      remarks: "",
      datenow: new Date(),

      activeDeniedDialog: false,
      activeRevisionDialog: false,
    };
  },
  created() {
    const payload = {
      sortBy: "OTDate",
      sortOrder: "Desc",
      pageNumber: 1,
      pageSize: -1,
      isApprover: true,
    };
    this.$store.dispatch("overtime/getAllEmployeeOvertime", payload);
  },

  computed: {
    getEmployeeOvertimeRequests() {
      return this.$store.state.overtime.employeeFiledOvertime;
    },
    onGetStatus() {
      return (data) => {
        var overtimeStatus = "";
        var c = data.approversOTs.length;
        data.approversOTs.forEach((a) => {
          if (a.isApproved && a.priorityId == 1) {
            if (c > 1) {
              overtimeStatus = "Partially Approved";
            } else overtimeStatus = "Approved";
          } else if (a.isApproved && a.priorityId == 2) {
            if (c > 2) {
              overtimeStatus = "Partially Approved";
            } else overtimeStatus = "Approved";
          } else if (data.isCancelled) {
            overtimeStatus = "Cancelled";
          } else if (a.isRevised) {
            overtimeStatus = "For Revision";
          } else if (a.isDenied) {
            overtimeStatus = "Denied";
          } else if (data.isRetracted) {
            overtimeStatus = "Retracted";
          } else if (data.isDraft) {
            overtimeStatus = "Draft";
          } else if (data.isSubmitted && overtimeStatus == "") {
            overtimeStatus = "For Approval";
          }

          // if(a.approverId == this.$store.state.AppActiveUser.uid)
          // this.priorityId = a.priorityId
        });
        return overtimeStatus;
      };
    },
    onCheckPriority() {
      return (approvers, status) => {
        var s = false;
        var priorityId = 0;
        approvers.approversOTs.forEach((a) => {
          if (a.approverId == this.$store.state.AppActiveUser.uid)
            priorityId = a.priorityId;
        });

        switch (priorityId) {
          case 1:
            if (status == "For Approval") s = true;
            else s = false;
            break;
          case 2:
          case 3:
            if (status == "Partially Approved") s = true;
            else s = false;
            break;
        }
        console.log(priorityId);
        console.log(s);
        return s;
      };
    },
    getCurrentDate() {
      return moment(new Date()).utc().format("YYYY-MM-DD");
    },
    approverName() {
      return this.$store.getters["overtime/approverName"](
        this.$store.state.AppActiveUser.uid
      );
    },

    validRemarks() {
      return this.remarks.length > 0;
    },
  },
  methods: {
    onApproved(filedOvertimeId) {
      Swal.fire({
        title: "Are you sure you want to <strong>continue</strong>?",
        text: "",
        icon: "warning",
        customClass: {
          icon: "no-before-icon",
        },
        showCancelButton: true,
        confirmButtonColor: "3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$vs.loading();
          const data = {
            employeeFiledOvertimeId: filedOvertimeId,
            action: "APPROVED",
            isUnread: false,
            isApproved: true,
            approvedOn: this.getCurrentDate,
            isRetracted: false,
            approverId: this.$store.state.AppActiveUser.uid,
          };
          this.$store
            .dispatch("overtime/onApproved", data)
            .then((response) => {
              this.$vs.loading.close();
              if (response.status == 200)
                this.$alert(
                  "You have successfully approved overtime request.",
                  "Approved Successfully",
                  "success"
                );
              else this.$alert("", response.statusText, "error");
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$alert(error.message, "Error", "error");
            });
        } else this.$alert("", "Cancelled", "info");
      });
    },
    onDenied(filedOvertimeId) {
      Swal.fire({
        title: "Are you sure you want to <strong>continue</strong>?",
        text: "Note: You will not be able to revert this once you click the Deny button",
        input: "text",
        inputPlaceholder: "Enter Remarks",
        icon: "warning",
        customClass: {
          icon: "no-before-icon",
        },
        showCancelButton: true,
        confirmButtonColor: "3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Deny",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value !== "") {
              resolve();
            } else {
              resolve("Remarks is Required!");
            }
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$vs.loading();
          this.remarks = result.value;
          const data = {
            employeeFiledOvertimeId: filedOvertimeId,
            action: "DENIED",
            isUnread: false,
            isDenied: true,
            deniedOn: this.getCurrentDate,
            isRetracted: false,
            comments: this.remarks,
            approverId: this.$store.state.AppActiveUser.uid,
          };
          this.$store
            .dispatch("overtime/onDenied", data)
            .then((response) => {
              this.$vs.loading.close();
              if (response.status == 200)
                this.$alert(
                  "You have successfully denied overtime request.",
                  "Denied Successfully",
                  "success"
                );
              else this.$alert("", response.statusText, "error");
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$alert(error.message, "Error", "error");
            });
        } else this.$alert("", "Cancelled", "info");
      });
      this.$vs.loading.close();
    },
    onForRevision(filedOvertimeId) {
      Swal.fire({
        title: "Are you sure you want to <strong>continue</strong>?",
        text: "",
        input: "text",
        inputPlaceholder: "Enter Remarks",
        icon: "warning",
        customClass: {
          icon: "no-before-icon",
        },
        showCancelButton: true,
        confirmButtonColor: "3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ask for revision?",
        inputValidator: (value) => {
          return new Promise((resolve) => {
            if (value !== "") {
              resolve();
            } else {
              resolve("Remarks is Required!");
            }
          });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.$vs.loading();
          this.remarks = result.value;
          const data = {
            employeeFiledOvertimeId: filedOvertimeId,
            action: "REVISED",
            isUnread: false,
            isRevised: true,
            forRevisionOn: this.getCurrentDate,
            isRetracted: false,
            comments: this.remarks,
            approverId: this.$store.state.AppActiveUser.uid,
          };
          this.$store
            .dispatch("overtime/onRevised", data)
            .then((response) => {
              this.$vs.loading.close();
              if (response.status == 200)
                this.$alert(
                  "You have successfully asked for overtime request revision.",
                  "Asking for Revision Successfully",
                  "success"
                );
              else this.$alert("", response.statusText, "error");
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.$alert(error.message, "Error", "error");
            });
        } else this.$alert("", "Cancelled", "info");
      });
      this.$vs.loading.close();
    },
    downloadFile(fileId) {
      this.$store.dispatch("downloadFile", fileId).then((response) => {
        // console.log(response.headers['content-disposition'].split('filename=')[1].split('\;')[0])
        let fileName = response.headers["content-disposition"]
          .split("filename=")[1]
          .split("\;")[0];
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName.replace('"', "").replace('"', "");
        // link.setAttribute('download', fileName )
        // document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>
